// extracted by mini-css-extract-plugin
module.exports = {"default":"MobMenu_default__hU6gU"};